import { create } from "zustand"

export const useAdminStore = create((set, get) => ({
    contextsPagePaginationData: null,
    setContextsPagePaginationData: (data) => set({ contextsPagePaginationData: data }),

    contextsPageFilters: {},
    setContextsPageFilters: (filters) => set({ contextsPageFilters: filters }),
}))
